export const containerStyles = 'flex flex-col'
export const avatarSectionStyles =
   'rounded-tl-2xl rounded-tr-2xl border border-b-0 p-6 flex flex-col justify-center items-center gap-6'
export const avatarImageStyles =
   'w-28 h-28 rounded-[120px] hover:scale-105 hover:shadow-md transition-all duration-300'
export const detailsSectionStyles =
   'rounded-bl-2xl rounded-br-2xl border p-6 flex flex-col gap-4'
export const fieldContainerStyles = 'flex flex-col gap-1'
export const dividerStyles = 'h-px'
export const labelStyles = 'text-sm-regular'
export const valueStyles = 'text-sm-semibold'
